<div *ngIf="enableLoader" class="overlay-loader loading-spinner"></div>

<div class="modal-header ">
    <h5 class="modal-title">{{'shipment.attatch' | cxTranslate}}</h5>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
</div>
    <div class="modal-body ">
        <div class="card-body rounded border">
            <div class="card p-4">

                <div class="row d-flex align-items-center">
                    <div class="col-md-2">
                        <img src="/images/feather_upload-cloud.svg" class="pr-1" alt="icon" width="48"
                            height="48">
                    </div>
                    <div class="col-md-5 ">
                        <div class="small">{{'shipment.SelectFile' | cxTranslate}}</div>
                        <div class="small">{{ 'batches.fileNoMoreThan10mb' | cxTranslate }}</div>
                    </div>
                    <div class="col-md-5 text-right">
                        <span class="d-none">
                            <input accept="application/pdf, image/jpg, image/jpeg, image/png" type="file" #fileInput ng2FileSelect [uploader]="uploader"
                                (onFileSelected)="onFileSelected($event)" />
                        </span>
                        <div class="btn-group" (click)="fileInput.click()">
                            <label for="files" class="btn btn-outline-primary p-2">{{'shipment.file' | cxTranslate}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div *ngIf="uploader.queue.length != 0">
                    <div class="fw-600 mb-2 mt-2">{{'shipment.added' | cxTranslate}}</div>
                </div>
                <!--uplaoded files show start-->
                <div *ngIf="fromComponent=='shipmentdetails'">
                    <div *ngFor="let item of shipData.attachments;  let i = index;">
                        <div (mouseenter)="hoverFileShow1(i)" (mouseleave)="hoverFileHide1(i)" class="small file d-flex">
                            <div class="col-md-12">
                                <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21"
                                    height="21"><span>{{item?.name || item?.documentName }}</span><span>.</span>
                                <a class="btn btn-sm text-primary shadow-none small" href="{{item.downloadURL}}" target="_blank">
                                    {{'home.recordpickup.preview' | cxTranslate}}</a>
                                <span class="float-right mt-3 fs-10">{{
                                    item?.size  / 1024 / 1024 | number: '.3'}} MB</span>
                            </div>
                            <div *ngIf="isHidden" class="float-right row" (click)="deleteFile(i)">
                                <span id="hover{{i}}" class="close-icon position-absolute text-center pe-auto"
                                    aria-hidden="true">&times;</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="fromComponent == 'batchesScreendetails'">
                    <div *ngFor="let item of batchScreenData?.screeningDocuments; let i = index;">
                        <div (mouseenter)="hoverFileShow1(i)" (mouseleave)="hoverFileHide1(i)" class="small file d-flex">
                            <div class="col-md-12">
                                <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21"
                                    height="21"><span>{{ item?.documentName }}</span><span>.</span>
                                <a class="mt-3 btn btn-sm text-primary shadow-none small" href="{{item.downloadURL}}" target="_blank">
                                        Preview</a>
                                <span class="float-right mt-3 fs-10">{{
                                    item?.size  / 1024 / 1024 | number: '.3'}} MB</span>
                            </div>
                            <div *ngIf="isHidden" class="float-right row" (click)="deleteFile(i)">
                                <span id="hover{{i}}" class="close-icon position-absolute text-center pe-auto"
                                    aria-hidden="true">&times;</span>
                            </div>
                        </div>
                    </div>
                </div>
               <div *ngIf="fromComponent == 'batchDeliveryDetails'">
                    <div *ngFor="let item of batchDeliveryData?.documents let i = index;">
                        <div (mouseenter)="hoverFileShow1(i)" (mouseleave)="hoverFileHide1(i)" class="small file d-flex">
                            <div class="col-md-12">
                                <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21"
                                    height="21"><span>{{ item?.documentName }}</span><span>.</span>
                                <a class="mt-3 btn btn-sm text-primary shadow-none small" href="{{item.downloadURL}}" target="_blank">
                                        Preview</a>
                                <span class="float-right mt-3 fs-10">{{
                                    item?.size  / 1024 / 1024 | number: '.3'}} MB</span>
                            </div>
                            <div *ngIf="isHidden" class="float-right row" (click)="deleteFile(i)">
                                <span id="hover{{i}}" class="close-icon position-absolute text-center pe-auto"
                                    aria-hidden="true">&times;</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--uplaoded files show end-->
                <div *ngFor="let item of fileArray; let i = index;">
                    <div (mouseenter)="hoverFileShow(i)" (mouseleave)="hoverFileHide(i)" class="small file d-flex">
                        <div class="col-md-12">
                            <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21"
                                height="21"><span>{{ item?.name }}</span><span>.</span><a
                                class="btn btn-sm text-primary small">{{'home.recordpickup.preview' | cxTranslate}}</a> <span class="float-right mt-3 fs-10">{{
                                item?.size / 1024 / 1024 | number: '.3' }} MB</span>
                        </div>
                        <div *ngIf="selected" class="float-right row" (click)="removeFile(i)">
                            <span id="remove{{i}}" class="close-icon position-absolute text-center pe-auto"
                                aria-hidden="true">&times;</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<div class="modal-footer">
<div class="float-right">
    <button type="button" class="btn btn-primary mr-2" (click)="save()"> {{ "home.quote.Save" | cxTranslate }}</button>
    <button type="button" class="btn btn-outline-secondary"
        (click)="activeModal.dismiss('close click')" data-dismiss="modal">{{'heading.Cancel' | cxTranslate}}</button>
    </div>
    </div>
